export default __webpack_public_path__ + "static/media/pousada_8.9fa1de06.jpg";